import { useAppAutenticationContext } from "../../msal/MsalAppAuthenticationProvider";
import accessDeniedImg from "../../img/logo-accessdenied.png";

export default function RoleBaseGuard({ page, children }) {
  const {
    accountInfo: { pagesAllow, roles },
  } = useAppAutenticationContext();

  if (pagesAllow.includes(page) || roles.includes("SpecialUser")) {
    return children;
  } else {
    return (
      <div className="row">
        <div className="col-sm-12 text-center">
          <img alt="access_denied" src={accessDeniedImg} />
        </div>
        <div className="col-sm-12 text-center">
          <h4>
            Please make sure that you are in role for access to this page,{" "}
            <b>Please try again or contact 02-586-6138.</b>
          </h4>
          <p>
            <b>Your roles :</b> {(roles || []).join(",")}
          </p>
          <a href="/login" className="btn btn-warning">
            Login
          </a>
        </div>
      </div>
    );
  }
}
